import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from './progressBar.scss';

const ProgressBar = props => {
    return (
        <div className={`${styles.progressBar} ${props.auth.user ? 'authed' : ''}`} style={{ width: `${props.width || props.progressBar.width}` }} />
    );
};

ProgressBar.propTypes = {
    width: PropTypes.string,
};

ProgressBar.defaultProps = {
    width: '',
};

const mapStateToProps = ({ progressBar, auth }) => {
    return { progressBar, auth };
};
export default connect(mapStateToProps)(ProgressBar);
